import axios from "axios"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Footer from "../../components/Footer/Footer.jsx"
import { ProductGridSkeleton } from "./ProductSkeletons"
import "./Product.css"

function formatPrice(value) {
    return new Intl.NumberFormat("ru-RU").format(value)
}

function hasProductPage(product) {
    return Boolean(product.page_title || product.page_summary || product.page_content || product.page_images)
}

function isPublicProduct(product) {
    return !product?.hidden
}

function isSellableProduct(product) {
    return !product?.hidden && !product?.info_only
}

export default function Product() {
    const [products, setProducts] = useState([])
    const [isLoading, setIsLoading] = useState(true)

    useEffect(() => {
        async function fetchProducts() {
            try {
                const response = await axios.get("/api/products")
                setProducts((response.data.data ?? []).filter(isPublicProduct))
            } catch (error) {
                console.error("Ошибка при загрузке продуктов", error)
            } finally {
                setIsLoading(false)
            }
        }

        fetchProducts()
    }, [])

    const hasSellableProducts = products.some(isSellableProduct)

    return (
        <>
            <main className="product">
                <section className="product__header product__header_calculator">
                    <h1>Выберите подходящее решение</h1>
                    {hasSellableProducts && (
                        <Link className="product__calculateButton" to="/product/calculator">
                            Рассчитать стоимость
                        </Link>
                    )}
                </section>

                {isLoading && <ProductGridSkeleton />}

                {!isLoading && products.length === 0 && (
                    <p className="product__message">Продукты пока не добавлены.</p>
                )}

                {!isLoading && products.length > 0 && (
                    <section className="product__grid">
                        {products.map((item) => {
                            const isClickable = hasProductPage(item)
                            const Card = isClickable ? Link : "article"
                            const cardProps = isClickable ? { to: `/product/${item.key}` } : {}

                            return (
                                <Card
                                    className={isClickable ? "product__card product__card_clickable" : "product__card"}
                                    key={item.key}
                                    {...cardProps}
                                >
                                    <div className="product__cardMedia">
                                        {item.image && <img src={item.image} alt={item.module} />}
                                    </div>

                                    <div className="product__cardBody">
                                        <h2>{item.module}</h2>
                                        <p>{item.design}</p>
                                        {item.info_only
                                            ? <span className="product__status">Скоро в продаже</span>
                                            : <strong>{formatPrice(item.price)} ₽ / человек</strong>
                                        }
                                    </div>
                                </Card>
                            )
                        })}
                    </section>
                )}
            </main>

            <Footer />
        </>
    )
}
